import clsx from 'clsx';
import { Body, Heading, IconButton } from 'copilot-design-system';
import { useContext } from 'react';

import { FlagsContext } from 'src/context';
import { useNoteModal } from 'src/features/notes/NoteModal/noteModalContext';
import {
  Note,
  useCreateNoteMutation,
  useDeleteNoteMutation,
  useListNotesQuery,
  useUpdateNoteMutation,
} from 'src/services/api/notesApi';

import { NotesList } from './notes-list/NotesList';

const NotesHeader = ({
  openNoteModal,
}: {
  openNoteModal: (note: Note | null) => void;
}) => {
  return (
    <div className="pr-3 flex justify-between px-4">
      <Heading size="base">Notes</Heading>
      <IconButton
        className="hover:cursor-pointer p-1 hover:bg-secondary-hover"
        label="Create"
        onClick={(e) => {
          // Prevents the accordion from toggling.
          e.stopPropagation();
          openNoteModal(null);
        }}
        icon="Plus"
        variant="minimal"
      />
    </div>
  );
};

const NotesListContent = ({
  notes,
  onClick,
}: {
  notes: Note[];
  onClick: (note: Note) => void;
}) => {
  if (!notes.length) {
    return (
      <div className="w-full flex justify-center items-center py-3">
        <Body className="text-secondary">Click + to add a note</Body>
      </div>
    );
  }
  return <NotesList notes={notes} onClick={onClick} />;
};
export const Notes = ({
  entityType,
  entityId,
}: {
  entityType: 'client' | 'company';
  entityId: string;
}) => {
  const { EnableContextBarVisualUpgrades } = useContext(FlagsContext);
  const { data } = useListNotesQuery({
    entityType,
    entityId,
    limit: 50,
  });
  // CLEANUP(EnableContextBarVisualUpgrades): Notes will not manage this state anymore after
  // this flag is removed.
  const [createNote] = useCreateNoteMutation();
  const [updateNote] = useUpdateNoteMutation();
  const [deleteNote] = useDeleteNoteMutation();
  const openNoteModal = useNoteModal({
    onDelete: async (note) => {
      await deleteNote({
        id: note.id,
        entityType: note.entityType,
        entityId: note.entityId,
      });
    },
    onSave: (title, content, note) => {
      if (note) {
        updateNote({
          id: note.id,
          title,
          content,
          entityType: note.entityType,
          entityId: note.entityId,
        });
      } else {
        createNote({
          entityType,
          entityId,
          title,
          content,
        });
      }
    },
  });

  return (
    <div
      className={clsx('w-full py-5', {
        ' h-[123px] box-border': !data?.data.length,
      })}
    >
      {/* CLEANUP(EnableContextBarVisualUpgrades): Remove NotesHeader and this conditional */}
      {!EnableContextBarVisualUpgrades && (
        <NotesHeader openNoteModal={openNoteModal} />
      )}
      <NotesListContent
        notes={data?.data ?? []}
        onClick={(note) => openNoteModal(note)}
      />
    </div>
  );
};
